module.exports = __webpack_public_path__ + "static/media/Group 51742@2x.5f9bb855.png";